import { h, Fragment } from 'preact'
import { useEffect } from 'preact/hooks'
import { ChatThread } from './ChatThread.jsx'
import { QuotaExceededModal } from '../../../components/shared/quota/QuotaExceededModal.jsx'
import { useQuotaGate } from '../../../components/shared/quota/useQuotaGate.js'

/**
 * Wraps ChatThread with the shared quota-exceeded modal for metered AI chat limits.
 */
export function AiChatShell({ store, formatter, onRegisterQuotaHandler }) {
  const gate = useQuotaGate({
    onBlocked: () => {
      store?.setStatus?.('error', null)
    }
  })

  useEffect(() => {
    onRegisterQuotaHandler?.((quota) => {
      if (!quota) return
      gate.captureBody(quota.raw ?? quota, 402)
    })
    return () => onRegisterQuotaHandler?.(null)
  }, [gate.captureBody, onRegisterQuotaHandler])

  return (
    <>
      <ChatThread store={store} formatter={formatter} />
      <QuotaExceededModal
        open={gate.open}
        quota={gate.quota}
        t={(key, opts) => store?.i18n?.t(key, opts)}
        onClose={gate.dismiss}
      />
    </>
  )
}

export default AiChatShell
